/**
 * Activity log stage — structure-scoped, nested in the site dashboard.
 *
 * Rendered as a child route of SiteDashboardLayout, inside the shared
 * dashboard shell (which supplies AppNav + TitleBar). Shows the site's
 * relay-event activity via the shared CommandLogGrid in "activity" mode.
 *
 * Contains:
 * - ActivityLogView — route child component (default export)
 */
import { Box } from '@mui/material';
import React from 'react';

import LoadingScreen from '@sophocles/components/LoadingScreen';
import CommandLogGrid from '@sophocles/views/sites/components/CommandLogGrid';
import { useSiteDashboardLayoutContext } from '@sophocles/views/sites/SiteDashboardLayout';

function ActivityLogView() {
  const { loading, site } = useSiteDashboardLayoutContext();

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <Box sx={{ pb: 2, display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
      <CommandLogGrid mode="activity" timeZone={site?.time_zone} />
    </Box>
  );
}

export default ActivityLogView;
